import { createClient } from '@supabase/supabase-js';

import { appConfig } from 'src/app/app-config';
import { ErrorMessage } from 'src/shared/enum/ErrorMessage';

if (!appConfig.supabase.anonKey || !appConfig.supabase.url)
    throw new Error(ErrorMessage.SUPABASE_DETAILS_MISSING);

export const supabaseClient = createClient(appConfig.supabase.url, appConfig.supabase.anonKey, {
    auth: {
        persistSession: false,
    },
});
